import { ChatItemReadController } from './chatReadInterface';
import { AiOutlineFileSearch, AiOutlineSearch } from 'react-icons/ai';

export function createChatItemReadController(): ChatItemReadController {
    return {
        useProps(context, item, props) {
            return {
                Icon: AiOutlineFileSearch,
                label: item.result
                    ? `Read "${item.result.document.title}"`
                    : 'Reading document',
            };
        },
    };
}
